var incidentDetails = (function () {

    //#region variables
    var SelectedIncidentId;
    var consumerId;
    var consumerInvolementId;
    var formReadOnly = false;

    // Incident Details variables
    var categories;
    var incidentLocations;
    var involvementTypes;
    var employeeNames;
    var incidentDate;
    var incidentTime;
    var reportedDate;
    var reportedTime;
    var categoryId;
    var locationId;
    var summaryText;
    var actionText;
    var preventionText;
    var factorsText;
    var reviewData;

    // Individuals Involved data
    var individualsInvolvedData = [];
    var employeesInvolvedData = [];
    var otherPeopleInvolvedData = [];

    // Inputs
    var incidentDateInput;
    var incidentTimeInput;
    var reportedDateInput;
    var reportedTimeInput;
    var summaryTextarea;
    var actionTextarea;
    var preventionTextarea;
    var causeTextarea;
    var categoryDropdown;
    var locationDetailDropdown;

    // Attachments
    let attachmentsBtn;
    let tempAttachmentArray = [];
    let reviewAttachmentArray = [];
    let attachmentCount = 0;

    // DOM elements
    var contentDiv;
    var incidentDetailsSection;

    // Tables
    var individualsTable;
    var employeesTable;
    var otherPeopleTable;
    //#endregion

    //#region common functions
    function buildNavigation() {
        var navEle = document.createElement('div');
        var ulEle = document.createElement('ul');
        // Incident Details Link
        var liIncidentDetailsEle = document.createElement('li');
        liIncidentDetailsEle.style.marginBottom = '15px';
        var linkIncidentDetailsEle = document.createElement('a');
        linkIncidentDetailsEle.textContent = 'Incident Details';
        linkIncidentDetailsEle.style.fontWeight = 'bold';
        linkIncidentDetailsEle.style.cursor = 'pointer';
        linkIncidentDetailsEle.classList.add('incident_details_link', 'active');
        liIncidentDetailsEle.appendChild(linkIncidentDetailsEle);
        ulEle.appendChild(liIncidentDetailsEle);

        // Individuals Involved Header
        var liIndividualsInvolvedTextEle = document.createElement('li');
        var pIndividualsInvolvedTextEle = document.createElement('p');
        pIndividualsInvolvedTextEle.textContent = 'Individuals Involved';
        pIndividualsInvolvedTextEle.style.fontWeight = 'bold';
        pIndividualsInvolvedTextEle.style.marginBottom = '10px';
        liIndividualsInvolvedTextEle.appendChild(pIndividualsInvolvedTextEle);
        liIndividualsInvolvedTextEle.style.marginBottom = '15px';
        ulEle.appendChild(liIndividualsInvolvedTextEle);

        // Get consumers involved in incident - ONLY if SelectedIncidentId exists
        if (SelectedIncidentId && reviewData && reviewData.length > 0 && reviewData[0].itConsumerInvolved) {
            reviewData[0].itConsumerInvolved.forEach(consumer => {
                var liIndividualEle = document.createElement('li');
                var linkIndividualEle = document.createElement('a');
                linkIndividualEle.textContent = `${consumer.firstName}, ${consumer.lastName}`;
                linkIndividualEle.style.cursor = 'pointer';
                linkIndividualEle.setAttribute('data-consumer-id', consumer.consumerId);
                linkIndividualEle.setAttribute('data-consumer-involvement-id', consumer.consumerInvolvedId);
                linkIndividualEle.classList.add('individual_nav');
                liIndividualEle.style.padding = '8px';
                liIndividualEle.appendChild(linkIndividualEle);
                ulEle.appendChild(liIndividualEle);
            });
        }

        navEle.appendChild(ulEle);
        return navEle;
    }

    function handleIndividualNavEvents(event) {
        var target = event.target;
        if (target.classList.contains('individual_nav')) {
            // Get consumer IDs
            consumerId = target.getAttribute('data-consumer-id');
            consumerInvolementId = target.getAttribute('data-consumer-involvement-id');

            // Navigate to consumer details section
            consumerDetails.init(SelectedIncidentId);

            // Trigger click on the corresponding consumer in consumerDetails
            setTimeout(() => {
                var consumerLink = document.querySelector(`a.individual_nav[data-consumer-id="${consumerId}"]`);
                if (consumerLink) {
                    consumerLink.click();
                }
            }, 100);
        }
    }
    //#endregion

    //#region Incident Details Section
    function getSectionData() {
        categories = incidentTracking.getCategories();
        incidentLocations = incidentTracking.getLocations();
    }

    function setSectionValues() {
        if (reviewData && reviewData.length > 0) {
            var rd = reviewData[0];
            incidentDate = rd.incidentDate ? UTIL.formatDateToIso(rd.incidentDate.split(' ')[0]) : '';
            incidentTime = rd.incidentTime ? rd.incidentTime : '';
            reportedDate = rd.reportedDate ? UTIL.formatDateToIso(rd.reportedDate.split(' ')[0]) : '';
            reportedTime = rd.reportedTime ? rd.reportedTime : '';
            categoryId = rd.subcategoryId ? rd.subcategoryId : '';
            locationId = rd.locationId ? rd.locationId : '';
            summaryText = rd.summary ? rd.summary : '';
            actionText = rd.note ? rd.note : '';
            preventionText = rd.prevention ? rd.prevention : '';
            factorsText = rd.contributingFactor ? rd.contributingFactor : '';

            if (rd.itAttachmentList) {
                reviewAttachmentArray = rd.itAttachmentList;
                attachmentCount = reviewAttachmentArray.length;
            }
        } else {
            var defaultCategory = categories.filter(c => c.incidentCategory === 'New Incident');
            incidentDate = $.session.incidentTrackingPopulateIncidentDate === 'Y' ? UTIL.getTodaysDate() : '';
            incidentTime = $.session.incidentTrackingPopulateIncidentTime === 'Y' ? UTIL.getCurrentTime() : '';
            reportedDate = $.session.incidentTrackingPopulateReportedDate === 'Y' ? UTIL.getTodaysDate() : '';
            reportedTime = $.session.incidentTrackingPopulateReportedTime === 'Y' ? UTIL.getCurrentTime() : '';
            categoryId = defaultCategory[0] ? defaultCategory[0].subcategoryId : '';
            locationId = '';
            summaryText = '';
            actionText = '';
            preventionText = '';
            factorsText = '';
        }
    }

    function buildDateTimeInputs() {
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '20px';

        incidentDateInput = input.build({
            label: 'Incident Date',
            id: 'incidentDateInpt',
            type: 'date',
            style: 'secondary',
            attributes: [{ key: 'max', value: '9999-12-31' }],
            value: incidentDate,
            readonly: formReadOnly
        });

        incidentTimeInput = input.build({
            label: 'Incident Time',
            type: 'time',
            style: 'secondary',
            value: incidentTime,
            readonly: formReadOnly
        });

        reportedDateInput = input.build({
            label: 'Reported Date',
            type: 'date',
            style: 'secondary',
            attributes: [{ key: 'max', value: '9999-12-31' }],
            value: reportedDate,
            readonly: formReadOnly
        });

        reportedTimeInput = input.build({
            label: 'Reported Time',
            type: 'time',
            style: 'secondary',
            value: reportedTime,
            readonly: formReadOnly
        });

        container.appendChild(incidentDateInput);
        container.appendChild(incidentTimeInput);
        container.appendChild(reportedDateInput);
        container.appendChild(reportedTimeInput);

        return container;
    }

    function buildDropdowns() {
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '20px';

        // Build category dropdown
        var categoryOpts = {
            label: 'Incident Category',
            style: 'secondary'
        };
        if (formReadOnly) categoryOpts.readonly = true;
        categoryDropdown = dropdown.build(categoryOpts);

        // Build location dropdown
        var locationOpts = {
            label: 'Incident Detail',
            style: 'secondary'
        };
        if (formReadOnly) locationOpts.readonly = true;
        locationDetailDropdown = dropdown.build(locationOpts);

        // Get and set data
        var categoryData = categories.map(c => {
            return {
                value: c.subcategoryId,
                text: c.incidentCategory,
            };
        });

        var locationData = incidentLocations.map(l => {
            return {
                value: l.itLocationId,
                text: l.description,
            };
        });

        var defaultDropdownOption = { value: '', text: '' };
        locationData.unshift(defaultDropdownOption);

        // Populate dropdowns
        dropdown.populate(categoryDropdown, categoryData, categoryId);
        dropdown.populate(locationDetailDropdown, locationData, locationId);

        // Append to wrapper
        container.appendChild(categoryDropdown);
        container.appendChild(locationDetailDropdown);

        return container;
    }

    function buildTextAreas() {
        var container = document.createElement('div');

        var textAreaOpts = {
            style: 'secondary',
            type: 'textarea'
        };

        if (formReadOnly) textAreaOpts.readonly = true;

        summaryTextarea = input.build({
            ...textAreaOpts,
            label: 'Summary of Incident',
            value: summaryText,
        });
        summaryTextarea.style.marginBottom = '20px';
        var summaryTA = summaryTextarea.querySelector('textarea');
        if (summaryTA) summaryTA.style.minHeight = '80px';

        actionTextarea = input.build({
            ...textAreaOpts,
            label: 'Immediate Action',
            value: actionText,
        });
        actionTextarea.style.marginBottom = '20px';
        var actionTA = actionTextarea.querySelector('textarea');
        if (actionTA) actionTA.style.minHeight = '80px';

        preventionTextarea = input.build({
            ...textAreaOpts,
            label: 'Prevention Plan',
            value: preventionText,
        });
        preventionTextarea.style.marginBottom = '20px';
        var preventionTA = preventionTextarea.querySelector('textarea');
        if (preventionTA) preventionTA.style.minHeight = '80px';

        causeTextarea = input.build({
            ...textAreaOpts,
            label: 'Cause & Contributing Factors',
            value: factorsText,
        });
        causeTextarea.style.marginBottom = '30px';
        var causeTA = causeTextarea.querySelector('textarea');
        if (causeTA) causeTA.style.minHeight = '80px';

        container.appendChild(summaryTextarea);
        container.appendChild(actionTextarea);
        if ($.session.incidentTrackingShowPreventionPlan) {
            container.appendChild(preventionTextarea);
        }
        if ($.session.incidentTrackingShowCauseAndContributingFactors) {
            container.appendChild(causeTextarea);
        }

        return container;
    }

    function buildIndividualsInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '30px';

        var heading = document.createElement('h3');
        heading.textContent = 'Individuals Involved';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        individualsTable = table.build({
            tableId: 'individualsInvolvedTable',
            columnHeadings: ['Individual', 'Involvement'],
            endIcon: true
        });
        individualsTable.style.marginBottom = '15px';
        sectionContainer.appendChild(individualsTable);

        // Populate table with consumers already in this incident
        if (reviewData && reviewData.length > 0 && reviewData[0].itConsumerInvolved && reviewData[0].itConsumerInvolved.length > 0) {
            populateIndividualsTable(reviewData[0].itConsumerInvolved);
            individualsInvolvedData = reviewData[0].itConsumerInvolved;
        }

        var addIndividualBtnWrap = document.createElement('div');
        addIndividualBtnWrap.style.display = 'flex';
        addIndividualBtnWrap.style.justifyContent = 'flex-end';
        addIndividualBtnWrap.style.marginBottom = '15px';
        addIndividualBtnWrap.style.textAlign = 'right';
        var addIndividualBtn = button.build({
            text: 'ADD INDIVIDUAL',
            style: 'secondary',
            type: 'contained',
            callback: function () {
                var individualFormSection = document.getElementById('individualFormSection');
                if (individualFormSection.style.display === 'none' || individualFormSection.style.display === '') {
                    // Clear form for new entry
                    individualFormSection.removeAttribute('data-edit-row-id');
                    var selects = individualFormSection.querySelectorAll('select');
                    selects.forEach(s => s.value = '');
                    var checkbox = individualFormSection.querySelector('input[type="checkbox"]');
                    if (checkbox) checkbox.checked = false;

                    individualFormSection.style.display = 'block';
                    addIndividualBtn.textContent = 'HIDE FORM';
                } else {
                    individualFormSection.style.display = 'none';
                    addIndividualBtn.textContent = 'ADD INDIVIDUAL';
                }
            }
        });
        addIndividualBtnWrap.appendChild(addIndividualBtn);
        sectionContainer.appendChild(addIndividualBtnWrap);

        // Individual Form (hidden by default)
        var individualFormSection = document.createElement('div');
        individualFormSection.id = 'individualFormSection';
        individualFormSection.style.display = 'none';
        individualFormSection.style.marginBottom = '30px';
        individualFormSection.style.padding = '20px';
        individualFormSection.style.border = '1px solid #ddd';
        individualFormSection.style.borderRadius = '4px';
        individualFormSection.style.backgroundColor = '#f9f9f9';

        var individualFormGrid = document.createElement('div');
        individualFormGrid.style.display = 'grid';
        individualFormGrid.style.gridTemplateColumns = '1fr 1fr';
        individualFormGrid.style.gap = '20px';
        individualFormGrid.style.marginBottom = '15px';

        var individualDropdown = dropdown.build({
            label: 'Individual',
            style: 'secondary',
            className: 'individualDropdown'
        });
        // POPULATE INDIVIDUAL DROPDOWN - Use reviewData that's already loaded
        var consumerData = [];
        if (reviewData && reviewData.length > 0 && reviewData[0].itConsumerInvolved) {
            consumerData = reviewData[0].itConsumerInvolved.map(consumer => ({
                value: consumer.consumerId,
                text: `${consumer.firstName} ${consumer.lastName}`
            }));
        }
        consumerData.unshift({ value: '', text: '' });
        dropdown.populate(individualDropdown, consumerData, '');

        individualFormGrid.appendChild(individualDropdown);

        var individualInvolvementDropdown = dropdown.build({
            label: 'Involvement',
            style: 'secondary',
            className: 'involvementDropdown'
        });

        // POPULATE INVOLVEMENT DROPDOWN
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementData = involvementTypes.map(it => {
            var involvementId = it.involvementId;
            return { value: involvementId, text: it.description };
        });
        involvementData.unshift({ value: '', text: '' });
        dropdown.populate(individualInvolvementDropdown, involvementData, '');

        individualFormGrid.appendChild(individualInvolvementDropdown);

        individualFormSection.appendChild(individualFormGrid);

        var locationDropdown = dropdown.build({
            label: 'Location',
            style: 'secondary',
            className: 'locationDropdown'
        });

        // POPULATE LOCATION DROPDOWN
        var locationData = incidentLocations.map(l => {
            return {
                value: l.itLocationId,
                text: l.description,
            };
        });
        locationData.unshift({ value: '', text: '' });
        dropdown.populate(locationDropdown, locationData, '');

        locationDropdown.style.marginBottom = '15px';
        individualFormSection.appendChild(locationDropdown);

        var includeInCountsWrap = document.createElement('div');
        includeInCountsWrap.style.marginBottom = '15px';
        var includeInCountsCheckbox = input.buildCheckbox({
            text: 'Include in Counts',
            isChecked: false
        });
        includeInCountsWrap.appendChild(includeInCountsCheckbox);
        individualFormSection.appendChild(includeInCountsWrap);

        var individualFormBtnWrap = document.createElement('div');
        individualFormBtnWrap.style.display = 'flex';
        individualFormBtnWrap.style.gap = '10px';
        individualFormBtnWrap.style.justifyContent = 'flex-end';

        var individualSaveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: function () {
                var indivSelect = individualFormSection.querySelector('.individualDropdown select');
                var involvementSelect = individualFormSection.querySelector('.involvementDropdown select');
                var locationSelect = individualFormSection.querySelector('.locationDropdown select');
                var includeCheckbox = individualFormSection.querySelector('input[type="checkbox"]');

                if (!indivSelect.value || !involvementSelect.value) {
                    alert('Individual and Involvement are required');
                    return;
                }

                var tbody = individualsTable.querySelector('.table__body') || individualsTable.querySelector('tbody');
                var editId = individualFormSection.getAttribute('data-edit-row-id');
                var row = editId ? tbody.querySelector(`tr[data-id="${editId}"]`) : null;

                var consumerId = indivSelect.value;
                var indivText = indivSelect.options[indivSelect.selectedIndex].text;
                var involvementText = involvementSelect.options[involvementSelect.selectedIndex].text;

                // Get location name
                var locationName = '';
                if (locationSelect.value) {
                    var loc = incidentLocations.find(l => l.itLocationId === locationSelect.value);
                    locationName = loc ? loc.description : '';
                }

                var includeInCountVal = includeCheckbox.checked ? 'Y' : 'N';

                if (row) {
                    // UPDATE existing row
                    row.setAttribute('data-consumer-id', consumerId);
                    row.setAttribute('data-involvement-id', involvementSelect.value);
                    row.setAttribute('data-involvement-type', involvementText);
                    row.setAttribute('data-location-id', locationSelect.value);
                    row.setAttribute('data-include-count', includeInCountVal);

                    row.children[0].textContent = indivText;
                    row.children[1].textContent = involvementText;
                    row.children[2].textContent = locationName;
                    row.children[3].textContent = includeInCountVal === 'Y' ? 'Yes' : 'No';

                    // Update individualsInvolvedData array
                    var dataIndex = individualsInvolvedData.findIndex(d =>
                        (d.consumerInvolvedId && d.consumerInvolvedId === editId) ||
                        (d.consumerId === consumerId)
                    );
                    if (dataIndex !== -1) {
                        individualsInvolvedData[dataIndex].involvementTypeId = involvementSelect.value;
                        individualsInvolvedData[dataIndex].involvementType = involvementText;
                        individualsInvolvedData[dataIndex].locationId = locationSelect.value;
                        individualsInvolvedData[dataIndex].includeInCount = includeInCountVal;
                    }
                } else {
                    // ADD new row (shouldn't happen often, but just in case)
                    var tr = document.createElement('tr');
                    tr.dataset.id = 'temp_' + Date.now();
                    tr.setAttribute('data-consumer-id', consumerId);
                    tr.setAttribute('data-involvement-id', involvementSelect.value);
                    tr.setAttribute('data-involvement-type', involvementText);
                    tr.setAttribute('data-location-id', locationSelect.value);
                    tr.setAttribute('data-include-count', includeInCountVal);

                    tr.innerHTML = `
    <td>${indivText}</td>
    <td>${involvementText}</td>
    <td class="endIcon" style="text-align: right;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
`;
                    tbody.appendChild(tr);

                    // Add to individualsInvolvedData
                    individualsInvolvedData.push({
                        consumerInvolvedId: tr.dataset.id,
                        consumerId: consumerId,
                        firstName: indivText.split(' ')[0],
                        lastName: indivText.split(' ').slice(1).join(' '),
                        involvementTypeId: involvementSelect.value,
                        involvementType: involvementText,
                        locationId: locationSelect.value,
                        includeInCount: includeInCountVal
                    });
                }

                individualFormSection.removeAttribute('data-edit-row-id');
                individualFormSection.style.display = 'none';
                addIndividualBtn.textContent = 'ADD INDIVIDUAL';
            }
        });

        var individualCancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: function () {
                individualFormSection.removeAttribute('data-edit-row-id');
                individualFormSection.style.display = 'none';
                addIndividualBtn.textContent = 'ADD INDIVIDUAL';
            }
        });

        individualFormBtnWrap.appendChild(individualSaveBtn);
        individualFormBtnWrap.appendChild(individualCancelBtn);
        individualFormSection.appendChild(individualFormBtnWrap);

        sectionContainer.appendChild(individualFormSection);

        // Add click event to table rows for EDIT
        individualsTable.addEventListener('click', function (e) {
            var row = e.target.closest('tr');

            // Handle row click for EDIT
            if (row && row.dataset.id && !e.target.closest('.endIcon')) {
                // Populate form with row data
                var consumerIdAttr = row.getAttribute('data-consumer-id');
                var involvementIdAttr = row.getAttribute('data-involvement-id');
                var locationIdAttr = row.getAttribute('data-location-id');
                var includeCount = row.getAttribute('data-include-count') === 'Y';

                // Find and populate dropdowns
                var indivDropdown = individualFormSection.querySelector('.individualDropdown select');
                if (indivDropdown && consumerIdAttr) {
                    indivDropdown.value = consumerIdAttr;
                }

                var involvementDropdown = individualFormSection.querySelector('.involvementDropdown select');
                if (involvementDropdown && involvementIdAttr) {
                    involvementDropdown.value = involvementIdAttr;
                }

                var locationDropdown = individualFormSection.querySelector('.locationDropdown select');
                if (locationDropdown && locationIdAttr) {
                    locationDropdown.value = locationIdAttr;
                }

                var checkbox = individualFormSection.querySelector('input[type="checkbox"]');
                if (checkbox) {
                    checkbox.checked = includeCount;
                }

                // Mark form as editing this row
                individualFormSection.setAttribute('data-edit-row-id', row.dataset.id);

                individualFormSection.style.display = 'block';
                addIndividualBtn.textContent = 'HIDE FORM';
            }

            // Handle delete icon click
            if (e.target.closest('.endIcon') && $.session.incidentTrackingDelete) {
                var row = e.target.closest('tr');
                if (row && confirm('Are you sure you want to delete this person?')) {
                    var rowId = row.dataset.id;
                    // Remove from data array
                    individualsInvolvedData = individualsInvolvedData.filter(d =>
                        d.consumerInvolvedId !== rowId && ('temp_' + d.consumerId) !== rowId
                    );
                    row.remove();
                }
            }
        });

        return sectionContainer;
    }

    function populateIndividualsTable(consumers) {
        var tbody = individualsTable.querySelector('.table__body') || individualsTable.querySelector('tbody');
        tbody.innerHTML = ''; // Clear existing rows

        consumers.forEach(consumer => {
            var tr = document.createElement('tr');
            tr.dataset.id = consumer.consumerInvolvedId || 'temp_' + consumer.consumerId;

            // Store all data in attributes
            tr.setAttribute('data-consumer-id', consumer.consumerId);
            tr.setAttribute('data-first-name', consumer.firstName);
            tr.setAttribute('data-last-name', consumer.lastName);
            tr.setAttribute('data-involvement-type', consumer.involvementType || '');
            tr.setAttribute('data-involvement-id', consumer.involvementTypeId || '');
            tr.setAttribute('data-location-id', consumer.locationId || '');
            tr.setAttribute('data-include-count', consumer.includeInCount || 'N');

            // Get location name
            var locationName = '';
            if (consumer.locationId) {
                var loc = incidentLocations.find(l => l.itLocationId === consumer.locationId);
                locationName = loc ? loc.description : '';
            }

            tr.innerHTML = `
    <td>${consumer.firstName} ${consumer.lastName}</td>
    <td>${consumer.involvementType || ''}</td>
    <td class="endIcon" style="text-align: right;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
`;

            tbody.appendChild(tr);
        });
    }

    function buildEmployeesInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '30px';

        var heading = document.createElement('h3');
        heading.textContent = 'Employees Involved';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        employeesTable = table.build({
            tableId: 'employeesInvolvedTable',
            columnHeadings: ['Employee', 'Involvement'],
            endIcon: true
        });
        employeesTable.style.marginBottom = '15px';
        sectionContainer.appendChild(employeesTable);

        // Populate table with existing data from reviewData
        if (reviewData && reviewData.length > 0 && reviewData[0].itEmployeeInvolved) {
            var tbody = employeesTable.querySelector('.table__body') || employeesTable.querySelector('tbody');
            reviewData[0].itEmployeeInvolved.forEach(emp => {
                var tr = document.createElement('tr');
                tr.dataset.id = emp.employeeInvolvedId;

                // Store data attributes for save
                tr.setAttribute('data-employee-id', emp.employeeId);
                tr.setAttribute('data-involvement-id', emp.employeeInvolvementTypeId);
                tr.setAttribute('data-notify', emp.notifyEmployee === 'Y' ? 'true' : 'false');
                tr.setAttribute('data-employee-name', `${emp.lastName}, ${emp.firstName}`);

                tr.innerHTML = `
                <td>${emp.lastName}, ${emp.firstName}</td>
                <td>${emp.description || ''}</td>
                <td class="endIcon">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
            `;

                tbody.appendChild(tr);
            });
            employeesInvolvedData = reviewData[0].itEmployeeInvolved;
        }

        var addEmployeeBtnWrap = document.createElement('div');
        addEmployeeBtnWrap.style.display = 'flex';
        addEmployeeBtnWrap.style.justifyContent = 'flex-end';
        addEmployeeBtnWrap.style.marginBottom = '15px';
        addEmployeeBtnWrap.style.textAlign = 'right';
        var addEmployeeBtn = button.build({
            text: 'ADD EMPLOYEE',
            style: 'secondary',
            type: 'contained',
            callback: function () {
                var employeeFormSection = document.getElementById('employeeFormSection');
                if (employeeFormSection.style.display === 'none' || employeeFormSection.style.display === '') {
                    // Clear form for new entry
                    employeeFormSection.removeAttribute('data-edit-row-id');
                    var nameSelect = employeeFormSection.querySelector('.employeeNameDropdown select');
                    var involvementSelect = employeeFormSection.querySelector('.involvmentTypeDropdown select');
                    var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');
                    if (nameSelect) nameSelect.value = '';
                    if (involvementSelect) involvementSelect.value = '';
                    if (notifyCheckbox) notifyCheckbox.checked = false;

                    employeeFormSection.style.display = 'block';
                    addEmployeeBtn.textContent = 'HIDE FORM';
                } else {
                    employeeFormSection.style.display = 'none';
                    addEmployeeBtn.textContent = 'ADD EMPLOYEE';
                }
            }
        });
        addEmployeeBtnWrap.appendChild(addEmployeeBtn);
        sectionContainer.appendChild(addEmployeeBtnWrap);

        // Employee Form (hidden by default)
        var employeeFormSection = document.createElement('div');
        employeeFormSection.id = 'employeeFormSection';
        employeeFormSection.style.display = 'none';
        employeeFormSection.style.marginBottom = '30px';
        employeeFormSection.style.padding = '20px';
        employeeFormSection.style.border = '1px solid #ddd';
        employeeFormSection.style.borderRadius = '4px';
        employeeFormSection.style.backgroundColor = '#f9f9f9';

        var employeeGrid = document.createElement('div');
        employeeGrid.style.display = 'grid';
        employeeGrid.style.gridTemplateColumns = '1fr 1fr';
        employeeGrid.style.gap = '20px';
        employeeGrid.style.marginBottom = '15px';

        // Employee Name Dropdown
        var employeeDropdown = dropdown.build({
            className: 'employeeNameDropdown',
            label: 'Employee',
            style: 'secondary',
            
        });

        var employeeNames = incidentTracking.getEmployeeNames();
        var employeeData = employeeNames.map(n => {
            return {
                value: n.employeeName,
                text: n.employeeName,
                attributes: [{ key: 'data-employeeid', value: n.employeeId }]
            };
        });
        employeeData.unshift({ value: '', text: '' });
        dropdown.populate(employeeDropdown, employeeData, '');

        employeeGrid.appendChild(employeeDropdown);

        // Employee Involvement Dropdown
        var employeeInvolvementDropdown = dropdown.build({
            className: 'involvmentTypeDropdown',
            label: 'Involvement',
            style: 'secondary',
            
        });

        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementData = involvementTypes.map(it => {
            var involvementId = it.involvementId === '%' ? '' : it.involvementId;
            return { value: involvementId, text: it.description };
        });
        involvementData.unshift({ value: '', text: '' });
        dropdown.populate(employeeInvolvementDropdown, involvementData, '');

        employeeGrid.appendChild(employeeInvolvementDropdown);

        employeeFormSection.appendChild(employeeGrid);

        var notifyCheckboxWrap = document.createElement('div');
        notifyCheckboxWrap.style.marginBottom = '15px';
        var notifyCheckbox = input.buildCheckbox({
            text: 'Notify Employee',
            isChecked: false
        });
        notifyCheckboxWrap.appendChild(notifyCheckbox);
        employeeFormSection.appendChild(notifyCheckboxWrap);

        var employeeFormBtnWrap = document.createElement('div');
        employeeFormBtnWrap.style.display = 'flex';
        employeeFormBtnWrap.style.gap = '10px';
        employeeFormBtnWrap.style.justifyContent = 'flex-end';

        var employeeSaveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: function () {
                var nameSelect = employeeFormSection.querySelector('.employeeNameDropdown select');
                var involvementSelect = employeeFormSection.querySelector('.involvmentTypeDropdown select');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');

                // Validation - just check if values exist
                if (!nameSelect.value || nameSelect.value === '') {
                    alert('Employee Name is required');
                    return;
                }

                if (!involvementSelect.value || involvementSelect.value === '') {
                    alert('Involvement Type is required');
                    return;
                }

                // Get selected employee ID and text
                var selectedOption = nameSelect.options[nameSelect.selectedIndex];
                var employeeId = selectedOption.getAttribute('data-employeeid');
                var employeeName = selectedOption.value;

                // Get involvement text
                var involvementText = involvementSelect.options[involvementSelect.selectedIndex].text;

                var tbody = employeesTable.querySelector('.table__body') || employeesTable.querySelector('tbody');
                var editId = employeeFormSection.getAttribute('data-edit-row-id');
                var row = editId ? tbody.querySelector(`tr[data-id="${editId}"]`) : null;

                if (row) {
                    // UPDATE existing row
                    row.setAttribute('data-employee-id', employeeId);
                    row.setAttribute('data-involvement-id', involvementSelect.value);
                    row.setAttribute('data-notify', notifyCheckbox && notifyCheckbox.checked ? 'true' : 'false');
                    row.setAttribute('data-employee-name', employeeName);
                    row.innerHTML = `
            <td>${employeeName}</td>
            <td>${involvementText}</td>
            <td class="endIcon" style="text-align: right; width: 50px;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
        `;

                    // Update employeesInvolvedData
                    var dataIndex = employeesInvolvedData.findIndex(d => d.employeeInvolvedId === editId);
                    if (dataIndex !== -1) {
                        employeesInvolvedData[dataIndex].employeeId = employeeId;
                        employeesInvolvedData[dataIndex].employeeInvolvementTypeId = involvementSelect.value;
                        employeesInvolvedData[dataIndex].description = involvementText;
                        employeesInvolvedData[dataIndex].notifyEmployee = notifyCheckbox && notifyCheckbox.checked ? 'Y' : 'N';
                        employeesInvolvedData[dataIndex].lastName = employeeName.split(',')[0]?.trim() || '';
                        employeesInvolvedData[dataIndex].firstName = employeeName.split(',')[1]?.trim() || '';
                    }
                } else {
                    // ADD new row
                    var tr = document.createElement('tr');
                    var newId = 'temp_' + Date.now();
                    tr.dataset.id = newId;
                    tr.setAttribute('data-employee-id', employeeId);
                    tr.setAttribute('data-involvement-id', involvementSelect.value);
                    tr.setAttribute('data-notify', notifyCheckbox && notifyCheckbox.checked ? 'true' : 'false');
                    tr.setAttribute('data-employee-name', employeeName);
                    tr.innerHTML = `
            <td>${employeeName}</td>
            <td>${involvementText}</td>
            <td class="endIcon" style="text-align: right; width: 50px;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
        `;
                    tbody.appendChild(tr);

                    // Add to employeesInvolvedData
                    if (!employeesInvolvedData) employeesInvolvedData = [];
                    employeesInvolvedData.push({
                        employeeInvolvedId: newId,
                        employeeId: employeeId,
                        employeeInvolvementTypeId: involvementSelect.value,
                        description: involvementText,
                        notifyEmployee: notifyCheckbox && notifyCheckbox.checked ? 'Y' : 'N',
                        lastName: employeeName.split(',')[0]?.trim() || '',
                        firstName: employeeName.split(',')[1]?.trim() || ''
                    });
                }

                // Clear form and hide
                employeeFormSection.removeAttribute('data-edit-row-id');
                nameSelect.value = '';
                involvementSelect.value = '';
                if (notifyCheckbox) notifyCheckbox.checked = false;
                employeeFormSection.style.display = 'none';
                addEmployeeBtn.textContent = 'ADD EMPLOYEE';
            }
        });

        var employeeCancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: function () {
                employeeFormSection.removeAttribute('data-edit-row-id');
                employeeFormSection.style.display = 'none';
                addEmployeeBtn.textContent = 'ADD EMPLOYEE';
            }
        });

        employeeFormBtnWrap.appendChild(employeeSaveBtn);
        employeeFormBtnWrap.appendChild(employeeCancelBtn);
        employeeFormSection.appendChild(employeeFormBtnWrap);

        sectionContainer.appendChild(employeeFormSection);

        // Add click event to table rows for EDIT
        employeesTable.addEventListener('click', function (e) {
            var row = e.target.closest('tr');

            // Handle row click for EDIT
            if (row && row.dataset.id && !e.target.closest('.endIcon')) {
                // Get stored data
                var employeeId = row.getAttribute('data-employee-id');
                var involvementId = row.getAttribute('data-involvement-id');
                var notify = row.getAttribute('data-notify') === 'true';

                // Populate form
                var nameSelect = employeeFormSection.querySelector('.employeeNameDropdown select');
                var involvementSelect = employeeFormSection.querySelector('.involvmentTypeDropdown select');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');

                if (nameSelect) {
                    // Find option by employee ID
                    for (var i = 0; i < nameSelect.options.length; i++) {
                        if (nameSelect.options[i].getAttribute('data-employeeid') === employeeId) {
                            nameSelect.value = nameSelect.options[i].value;
                            break;
                        }
                    }
                }

                if (involvementSelect) involvementSelect.value = involvementId;
                if (notifyCheckbox) notifyCheckbox.checked = notify;

                // Mark as editing
                employeeFormSection.setAttribute('data-edit-row-id', row.dataset.id);

                employeeFormSection.style.display = 'block';
                addEmployeeBtn.textContent = 'HIDE FORM';
            }

            // Handle delete icon click
            if (e.target.closest('.endIcon') && $.session.incidentTrackingDelete) {
                var row = e.target.closest('tr');
                if (row && confirm('Are you sure you want to delete this employee?')) {
                    row.remove();
                }
            }
        });

        return sectionContainer;
    }

    function displayOtherPeopleCount() {
        var table = document.getElementById('otherPeopleInvolvedTable');
        if (!table) return;

        var rows = table.querySelectorAll('tbody tr');
        var count = rows ? rows.length : 0;
        var countHolder = document.querySelector('#otherPeopleSection span[data-count="people"]');
        if (countHolder) {
            countHolder.innerHTML = `( ${count} )`;
        }
    }

    function buildOtherPersonCard(values) {
        // values = {name, company, involvementTypeId, address1, address2, city, state, zipCode, phone}
        var name = values ? values.name : '';
        var company = values ? values.company : '';
        var involvementId = values ? values.involvementTypeId : '';
        var address1 = values ? values.address1 : '';
        var address2 = values ? values.address2 : '';
        var city = values ? values.city : '';
        var state = values ? values.state : '';
        var zip = values ? values.zipCode : '';
        var phone = values ? values.phone : '';

        var otherPeopleRow = document.createElement('div');
        otherPeopleRow.classList.add('peopleRow');
        otherPeopleRow.style.marginBottom = '20px';
        otherPeopleRow.style.padding = '20px';
        otherPeopleRow.style.border = '1px solid #ddd';
        otherPeopleRow.style.borderRadius = '4px';
        otherPeopleRow.style.backgroundColor = '#f9f9f9';

        var nameInput = input.build({
            label: 'Name',
            type: 'text',
            style: 'secondary',
            classNames: ['name'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: name,
            callbackType: 'input',
            callback: event => {
                if (event.target.value === '') {
                    nameInput.classList.add('error');
                } else {
                    nameInput.classList.remove('error');
                }
                checkRequiredFields();
            }
        });

        var companyInput = input.build({
            label: 'Company',
            type: 'text',
            style: 'secondary',
            classNames: ['company'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: company,
        });

        var involvementDropdown = dropdown.build({
            label: 'Involvement Type',
            style: 'secondary',
            className: 'involvmentTypeDropdown',
            callback: e => {
                if (!e.target.value || e.target.value === '%') {
                    involvementDropdown.classList.add('error');
                } else {
                    involvementDropdown.classList.remove('error');
                }
                checkRequiredFields();
            },
        });

        var address1Input = input.build({
            label: 'Address 1',
            type: 'text',
            style: 'secondary',
            classNames: ['address1'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: address1,
        });

        var address2Input = input.build({
            label: 'Address 2',
            type: 'text',
            style: 'secondary',
            classNames: ['address2'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: address2,
        });

        var cityInput = input.build({
            label: 'City',
            type: 'text',
            style: 'secondary',
            classNames: ['city'],
            attributes: [{ key: 'maxlength', value: '27' }],
            value: city,
        });

        var stateInput = input.build({
            label: 'State',
            type: 'text',
            style: 'secondary',
            classNames: ['state'],
            attributes: [{ key: 'maxlength', value: '2' }],
            value: state,
        });

        var zipInput = input.build({
            label: 'Zip Code',
            type: 'text',
            style: 'secondary',
            classNames: ['zip'],
            attributes: [{ key: 'maxlength', value: '9' }],
            value: zip,
        });

        var phoneInput = input.build({
            label: 'Phone',
            type: 'tel',
            style: 'secondary',
            classNames: ['phone'],
            attributes: [{ key: 'maxlength', value: '14' }],
            value: phone,
        });

        var deleteBtn = button.build({
            text: 'Delete Person',
            icon: 'delete',
            type: 'text',
            style: 'secondary',
            callback: function () {
                var parent = otherPeopleRow.parentElement;
                parent.removeChild(otherPeopleRow);
                displayOtherPeopleCount();
                checkRequiredFields();
            },
        });

        if (!name) {
            nameInput.classList.add('error');
        }

        // Populate dropdowns
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementDropdownData = involvementTypes.map(it => {
            var involvementIdValue = it.involvementId === '%' ? '' : it.involvementId;
            return { value: involvementIdValue, text: it.description };
        });
        var defaultValue = { value: '', text: '' };
        involvementDropdownData.unshift(defaultValue);
        dropdown.populate(involvementDropdown, involvementDropdownData, involvementId);

        if (!involvementId) {
            involvementDropdown.classList.add('error');
        }

        // Build card layout
        var wrap1 = document.createElement('div');
        var wrap2 = document.createElement('div');
        var wrap3 = document.createElement('div');
        wrap1.style.display = 'grid';
        wrap1.style.gridTemplateColumns = '1fr 1fr';
        wrap1.style.gap = '20px';
        wrap1.style.marginBottom = '15px';
        wrap2.style.display = 'grid';
        wrap2.style.gridTemplateColumns = '1fr 1fr';
        wrap2.style.gap = '20px';
        wrap2.style.marginBottom = '15px';
        wrap3.style.display = 'grid';
        wrap3.style.gridTemplateColumns = '1fr 1fr 1fr';
        wrap3.style.gap = '20px';
        wrap3.style.marginBottom = '15px';

        wrap1.appendChild(nameInput);
        wrap1.appendChild(companyInput);

        wrap2.appendChild(address1Input);
        wrap2.appendChild(address2Input);

        wrap3.appendChild(cityInput);
        wrap3.appendChild(stateInput);
        wrap3.appendChild(zipInput);

        otherPeopleRow.appendChild(deleteBtn);
        otherPeopleRow.appendChild(wrap1);
        otherPeopleRow.appendChild(involvementDropdown);
        otherPeopleRow.appendChild(wrap2);
        otherPeopleRow.appendChild(wrap3);
        otherPeopleRow.appendChild(phoneInput);

        return otherPeopleRow;
    }

    

    function buildOtherPeopleInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '30px';

        var heading = document.createElement('h3');
        heading.textContent = 'Other People Involved';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        // Table with all fields
        otherPeopleTable = table.build({
            tableId: 'otherPeopleInvolvedTable',
            columnHeadings: ['Other Person', 'Involvement'],
            endIcon: true
        });
        otherPeopleTable.style.marginBottom = '15px';
        sectionContainer.appendChild(otherPeopleTable);

        // Populate existing data
        if (reviewData && reviewData.length > 0 && reviewData[0].itOtherPeopleInvolved) {
            var tbody = otherPeopleTable.querySelector('.table__body') || otherPeopleTable.querySelector('tbody');
            reviewData[0].itOtherPeopleInvolved.forEach(person => {
                var tr = document.createElement('tr');
                tr.dataset.id = person.otherPersonId || 'temp_' + Date.now();
                tr.setAttribute('data-name', person.name || '');
                tr.setAttribute('data-company', person.company || '');
                tr.setAttribute('data-involvement-id', person.involvementTypeId || '');
                tr.setAttribute('data-involvement-text', person.involvementTypeDescription || '');
                tr.setAttribute('data-address1', person.address1 || '');
                tr.setAttribute('data-address2', person.address2 || '');
                tr.setAttribute('data-city', person.city || '');
                tr.setAttribute('data-state', person.state || '');
                tr.setAttribute('data-zip', person.zipCode || '');
                tr.setAttribute('data-phone', person.phone || '');

                tr.innerHTML = `
                <td>${person.name || ''}</td>
                <td>${person.involvementTypeDescription || ''}</td>
                <td class="endIcon" style="text-align: right; width: 50px;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
                `;
                tbody.appendChild(tr);
            });
            otherPeopleInvolvedData = reviewData[0].itOtherPeopleInvolved;
        }

        // ADD BUTTON
        var addBtnWrap = document.createElement('div');
        addBtnWrap.style.display = 'flex';
        addBtnWrap.style.justifyContent = 'flex-end';
        addBtnWrap.style.marginBottom = '15px';
        addBtnWrap.style.textAlign = 'right';

        var addBtn = button.build({
            text: 'ADD PERSON',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                otherPersonFormSection.removeAttribute('data-edit-row-id');

                // Clear all form fields
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                otherPersonFormSection.querySelectorAll('select').forEach(sel => sel.value = '');

                otherPersonFormSection.style.display =
                    otherPersonFormSection.style.display === 'none' ? 'block' : 'none';
                addBtn.textContent = otherPersonFormSection.style.display === 'block' ? 'HIDE FORM' : 'ADD PERSON';
            }
        });
        addBtnWrap.appendChild(addBtn);
        sectionContainer.appendChild(addBtnWrap);

        // Form (hidden by default)
        var otherPersonFormSection = document.createElement('div');
        otherPersonFormSection.id = 'otherPersonFormSection';
        otherPersonFormSection.style.display = 'none';
        otherPersonFormSection.style.padding = '20px';
        otherPersonFormSection.style.border = '1px solid #ddd';
        otherPersonFormSection.style.borderRadius = '4px';
        otherPersonFormSection.style.backgroundColor = '#f9f9f9';
        otherPersonFormSection.style.marginBottom = '30px';

        // Name and Company
        var grid1 = document.createElement('div');
        grid1.style.display = 'grid';
        grid1.style.gridTemplateColumns = '1fr 1fr';
        grid1.style.gap = '20px';
        grid1.style.marginBottom = '15px';

        var nameInput = input.build({ label: 'Name*', type: 'text', style: 'secondary', classNames: ['nameInput'] });
        var companyInput = input.build({ label: 'Company', type: 'text', style: 'secondary', classNames: ['companyInput'] });

        grid1.appendChild(nameInput);
        grid1.appendChild(companyInput);
        otherPersonFormSection.appendChild(grid1);

        // Involvement
        var involvementDropdown = dropdown.build({ label: 'Involvement*', style: 'secondary', className: 'involvementDropdown' });

        var involvementTypes = incidentTracking.getInvolvementTypes();
        var invData = involvementTypes.map(it => ({
            value: it.involvementId === '%' ? '' : it.involvementId,
            text: it.description
        }));
        invData.unshift({ value: '', text: '' });
        dropdown.populate(involvementDropdown, invData, '');

        otherPersonFormSection.appendChild(involvementDropdown);

        // Address fields
        var grid2 = document.createElement('div');
        grid2.style.display = 'grid';
        grid2.style.gridTemplateColumns = '1fr 1fr';
        grid2.style.gap = '20px';
        grid2.style.marginBottom = '15px';

        var address1Input = input.build({ label: 'Address 1', type: 'text', style: 'secondary', classNames: ['address1Input'] });
        var address2Input = input.build({ label: 'Address 2', type: 'text', style: 'secondary', classNames: ['address2Input'] });

        grid2.appendChild(address1Input);
        grid2.appendChild(address2Input);
        otherPersonFormSection.appendChild(grid2);

        // City, State, Zip
        var grid3 = document.createElement('div');
        grid3.style.display = 'grid';
        grid3.style.gridTemplateColumns = '1fr 1fr 1fr';
        grid3.style.gap = '20px';
        grid3.style.marginBottom = '15px';

        var cityInput = input.build({ label: 'City', type: 'text', style: 'secondary', classNames: ['cityInput'] });
        var stateInput = input.build({ label: 'State', type: 'text', style: 'secondary', classNames: ['stateInput'] });
        var zipInput = input.build({ label: 'Zip', type: 'text', style: 'secondary', classNames: ['zipInput'] });

        grid3.appendChild(cityInput);
        grid3.appendChild(stateInput);
        grid3.appendChild(zipInput);
        otherPersonFormSection.appendChild(grid3);

        // Phone
        var phoneInput = input.build({ label: 'Phone', type: 'tel', style: 'secondary', classNames: ['phoneInput'] });
        phoneInput.style.marginBottom = '15px';
        otherPersonFormSection.appendChild(phoneInput);

        // Save / Cancel buttons
        var btnWrap = document.createElement('div');
        btnWrap.style.display = 'flex';
        btnWrap.style.gap = '10px';
        btnWrap.style.justifyContent = 'flex-end';

        var saveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                var nameVal = nameInput.querySelector('input').value.trim();
                var companyVal = companyInput.querySelector('input').value.trim();
                var involvementId = involvementDropdown.querySelector('select').value;
                var involvementText = involvementDropdown.querySelector('select').options[
                    involvementDropdown.querySelector('select').selectedIndex
                ].text;
                var address1Val = address1Input.querySelector('input').value.trim();
                var address2Val = address2Input.querySelector('input').value.trim();
                var cityVal = cityInput.querySelector('input').value.trim();
                var stateVal = stateInput.querySelector('input').value.trim();
                var zipVal = zipInput.querySelector('input').value.trim();
                var phoneVal = phoneInput.querySelector('input').value.trim();

                if (!nameVal || !involvementId) {
                    alert('Name and Involvement are required');
                    return;
                }

                var tbody = otherPeopleTable.querySelector('.table__body') || otherPeopleTable.querySelector('tbody');

                // Check if editing
                var editId = otherPersonFormSection.getAttribute('data-edit-row-id');
                var row = editId ? tbody.querySelector(`tr[data-id="${editId}"]`) : null;

                if (row) {
                    // Update existing row
                    row.setAttribute('data-name', nameVal);
                    row.setAttribute('data-company', companyVal);
                    row.setAttribute('data-involvement-id', involvementId);
                    row.setAttribute('data-involvement-text', involvementText);
                    row.setAttribute('data-address1', address1Val);
                    row.setAttribute('data-address2', address2Val);
                    row.setAttribute('data-city', cityVal);
                    row.setAttribute('data-state', stateVal);
                    row.setAttribute('data-zip', zipVal);
                    row.setAttribute('data-phone', phoneVal);
                       
                    row.innerHTML = `
                    <td>${nameVal}</td>
                    <td>${involvementText}</td>
                    <td class="endIcon" style="text-align: right; width: 50px;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
                    `;

                    // Update otherPeopleInvolvedData
                    var dataIndex = otherPeopleInvolvedData.findIndex(d => d.otherPersonId === editId);
                    if (dataIndex !== -1) {
                        otherPeopleInvolvedData[dataIndex] = {  
                            otherPersonId: editId,
                            name: nameVal,
                            company: companyVal,
                            involvementTypeId: involvementId,
                            involvementTypeDescription: involvementText,
                            address1: address1Val,
                            address2: address2Val,
                            city: cityVal,
                            state: stateVal,
                            zipCode: zipVal,
                            phone: phoneVal
                        };
                    }

                    otherPersonFormSection.removeAttribute('data-edit-row-id');
                } else {
                    // Create new row
                    var tr = document.createElement('tr');
                    tr.dataset.id = 'temp_' + Date.now();
                    tr.setAttribute('data-name', nameVal);
                    tr.setAttribute('data-company', companyVal);
                    tr.setAttribute('data-involvement-id', involvementId);
                    tr.setAttribute('data-involvement-text', involvementText);
                    tr.setAttribute('data-address1', address1Val);
                    tr.setAttribute('data-address2', address2Val);
                    tr.setAttribute('data-city', cityVal);
                    tr.setAttribute('data-state', stateVal);
                    tr.setAttribute('data-zip', zipVal);
                    tr.setAttribute('data-phone', phoneVal);

                    tr.innerHTML = `
                    <td>${nameVal}</td>
                    <td>${involvementText}</td>
                    <td class="endIcon" style="text-align: right; width: 50px;">${$.session.incidentTrackingDelete ? icons['delete'] : icons['Empty']}</td>
                    `;
                    tbody.appendChild(tr);

                    // Add to otherPeopleInvolvedData
                    if (!otherPeopleInvolvedData) otherPeopleInvolvedData = [];
                    otherPeopleInvolvedData.push({
                        otherPersonId: tr.dataset.id,
                        name: nameVal,
                        company: companyVal,
                        involvementTypeId: involvementId,
                        involvementTypeDescription: involvementText,
                        address1: address1Val,
                        address2: address2Val,
                        city: cityVal,
                        state: stateVal,
                        zipCode: zipVal,
                        phone: phoneVal
                    });
                }

                // Clear and hide form
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                involvementDropdown.querySelector('select').value = '';
                otherPersonFormSection.style.display = 'none';
                addBtn.textContent = 'ADD PERSON';
            }
        });

        var cancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: () => {
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                involvementDropdown.querySelector('select').value = '';
                otherPersonFormSection.removeAttribute('data-edit-row-id');
                otherPersonFormSection.style.display = 'none';
                addBtn.textContent = 'ADD PERSON';
            }
        });

        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        otherPersonFormSection.appendChild(btnWrap);
        sectionContainer.appendChild(otherPersonFormSection);

        // Edit & Delete handling
        otherPeopleTable.addEventListener('click', e => {
            var row = e.target.closest('tr');
            if (!row || !row.dataset.id) return;

            if (e.target.closest('.endIcon') && $.session.incidentTrackingDelete) {
                if (confirm('Delete this person?')) {
                    var rowId = row.dataset.id;
                    // Remove from data array
                    otherPeopleInvolvedData = otherPeopleInvolvedData.filter(d => d.otherPersonId !== rowId);
                    row.remove();
                }
                return;
            }

            // Edit – populate form with all fields
            if (!e.target.closest('.endIcon')) {
                nameInput.querySelector('input').value = row.dataset.name || '';
                companyInput.querySelector('input').value = row.dataset.company || '';
                involvementDropdown.querySelector('select').value = row.dataset.involvementId || '';
                address1Input.querySelector('input').value = row.dataset.address1 || '';
                address2Input.querySelector('input').value = row.dataset.address2 || '';
                cityInput.querySelector('input').value = row.dataset.city || '';
                stateInput.querySelector('input').value = row.dataset.state || '';
                zipInput.querySelector('input').value = row.dataset.zip || '';
                phoneInput.querySelector('input').value = row.dataset.phone || '';

                otherPersonFormSection.setAttribute('data-edit-row-id', row.dataset.id);
                otherPersonFormSection.style.display = 'block';
                addBtn.textContent = 'HIDE FORM';
            }
        });

        return sectionContainer;
    }

    function buildIncidentDetailsContent() {
        var mainContainer = document.createElement('div');
        mainContainer.classList.add('incidentSection');
        mainContainer.style.padding = '20px';
        mainContainer.style.maxWidth = '1200px';

        // Heading
        var heading = document.createElement('h3');
        heading.textContent = 'Incident Details';
        heading.style.marginBottom = '30px';
        heading.style.fontSize = '24px';
        mainContainer.appendChild(heading);

        getSectionData();
        setSectionValues();

        var dateTimeInputs = buildDateTimeInputs();
        var dropdowns = buildDropdowns();
        var textAreas = buildTextAreas();

        // Attachments button
       

        // Append all elements
        mainContainer.appendChild(dateTimeInputs);
        mainContainer.appendChild(dropdowns);
        mainContainer.appendChild(textAreas);

        // Append Individuals/Employees/Other People sections
        mainContainer.appendChild(buildIndividualsInvolvedSection());
        mainContainer.appendChild(buildEmployeesInvolvedSection());
        mainContainer.appendChild(buildOtherPeopleInvolvedSection());

        // Save and Cancel buttons
        if ($.session.incidentTrackingUpdate && !formReadOnly) {
            var buttonWrap = document.createElement('div');
            buttonWrap.classList.add('btnWrap');
            buttonWrap.style.display = 'flex';
            buttonWrap.style.gap = '15px';
            buttonWrap.style.justifyContent = 'flex-end';
            buttonWrap.style.marginTop = '30px';
            buttonWrap.style.paddingTop = '20px';
            buttonWrap.style.borderTop = '1px solid #e0e0e0';

            var saveBtn = button.build({
                text: 'SAVE',
                type: 'contained',
                style: 'secondary',
                callback: function () {
                    saveIncidentDetails();
                }
            });
            buttonWrap.appendChild(saveBtn);

            var cancelBtn = button.build({
                text: 'CANCEL',
                type: 'outlined',
                style: 'secondary',
                callback: incidentOverview.init
            });
            buttonWrap.appendChild(cancelBtn);

            mainContainer.appendChild(buttonWrap);
        }

        setupIncidentDetailsEvents();

        return mainContainer;
    }

    function setupIncidentDetailsEvents() {
        if (incidentDateInput) {
            incidentDateInput.addEventListener('change', e => {
                incidentDate = e.target.value;
                checkRequiredFields();
            });
        }

        if (incidentTimeInput) {
            incidentTimeInput.addEventListener('change', e => {
                incidentTime = e.target.value;
            });
        }

        if (reportedDateInput) {
            reportedDateInput.addEventListener('change', e => {
                reportedDate = e.target.value;
            });
        }

        if (reportedTimeInput) {
            reportedTimeInput.addEventListener('change', e => {
                reportedTime = e.target.value;
            });
        }

        if (summaryTextarea) {
            summaryTextarea.addEventListener('change', e => {
                summaryText = e.target.value;
            });
        }

        if (actionTextarea) {
            actionTextarea.addEventListener('change', e => {
                actionText = e.target.value;
            });
        }

        if (preventionTextarea) {
            preventionTextarea.addEventListener('change', e => {
                preventionText = e.target.value;
            });
        }

        if (causeTextarea) {
            causeTextarea.addEventListener('change', e => {
                factorsText = e.target.value;
            });
        }

        if (categoryDropdown) {
            categoryDropdown.addEventListener('change', e => {
                categoryId = e.target.value;
            });
        }

        if (locationDetailDropdown) {
            locationDetailDropdown.addEventListener('change', e => {
                locationId = e.target.value;
            });
        }
    }

    function checkRequiredFields() {
        var incidentDateInpt = document.getElementById('incidentDateInpt');

        if (incidentDateInpt) {
            if (!incidentDate || incidentDate === '') {
                incidentDateInpt.classList.add('error');
                return true; // has errors
            } else {
                incidentDateInpt.classList.remove('error');
            }
        }

        var detailsHasErrors = incidentDetailsSection
            ? [].slice.call(incidentDetailsSection.querySelectorAll('.error'))
            : [];

        return detailsHasErrors.length !== 0;
    }

    function saveIncidentDetails() {
        if (checkRequiredFields()) {
            alert('Please fix validation errors before saving');
            return;
        }

        // Get values from inputs
        var iDateInput = incidentDateInput.querySelector('input');
        var iTimeInput = incidentTimeInput.querySelector('input');
        var rDateInput = reportedDateInput.querySelector('input');
        var rTimeInput = reportedTimeInput.querySelector('input');
        var summaryTA = summaryTextarea.querySelector('textarea');
        var actionTA = actionTextarea.querySelector('textarea');
        var preventionTA = preventionTextarea ? preventionTextarea.querySelector('textarea') : null;
        var causeTA = causeTextarea ? causeTextarea.querySelector('textarea') : null;
        var categorySelect = categoryDropdown.querySelector('select');
        var locationSelect = locationDetailDropdown.querySelector('select');

        // Collect Individuals Involved data from TABLE
        var individualsRows = individualsTable ? [].slice.call(individualsTable.querySelectorAll('tbody tr')) : [];
        var consumerIds = [];
        var consumerInvolvementIds = [];
        var consumerLocationIds = [];
        var consumerIncludeCounts = [];
        var consumerInvolvedIds = [];

        individualsRows.forEach(row => {
            var consumerId = row.getAttribute('data-consumer-id') || '';
            var involvementId = row.getAttribute('data-involvement-id') || '';
            var locationId = row.getAttribute('data-location-id') || '';
            var includeCount = row.getAttribute('data-include-count') === 'Y' ? 'Y' : 'N';
            var consumerInvolvedId = row.dataset.id || '';

            // Only include real IDs (not temporary ones)
            if (!consumerInvolvedId.startsWith('temp_')) {
                consumerInvolvedIds.push(consumerInvolvedId);
            } else {
                consumerInvolvedIds.push('');
            }

            consumerIds.push(consumerId);
            consumerInvolvementIds.push(involvementId);
            consumerLocationIds.push(locationId);
            consumerIncludeCounts.push(includeCount);
        });

        // Collect Employees Involved data from TABLE
        var employeesRows = employeesTable ? [].slice.call(employeesTable.querySelectorAll('tbody tr')) : [];
        var employeeIds = [];
        var employeeInvolvementIds = [];
        var notifyEmployees = [];

        employeesRows.forEach(row => {
            var employeeId = row.getAttribute('data-employee-id') || '';
            var involvementId = row.getAttribute('data-involvement-id') || '';
            var notify = row.getAttribute('data-notify') === 'true' ? 'Y' : 'N';

            employeeIds.push(employeeId);
            employeeInvolvementIds.push(involvementId);
            notifyEmployees.push(notify);
        });

        // Collect Other People Involved data from TABLE
        var otherPeopleRows = otherPeopleTable ? [].slice.call(otherPeopleTable.querySelectorAll('tbody tr')) : [];
        var names = [];
        var companies = [];
        var addresses1 = [];
        var addresses2 = [];
        var cities = [];
        var states = [];
        var zips = [];
        var phones = [];
        var involvementTypes = [];

        otherPeopleRows.forEach(row => {
            names.push(UTIL.removeUnsavableNoteText(row.getAttribute('data-name') || ''));
            companies.push(UTIL.removeUnsavableNoteText(row.getAttribute('data-company') || ''));
            addresses1.push(UTIL.removeUnsavableNoteText(row.getAttribute('data-address1') || ''));
            addresses2.push(UTIL.removeUnsavableNoteText(row.getAttribute('data-address2') || ''));
            cities.push(UTIL.removeUnsavableNoteText(row.getAttribute('data-city') || ''));
            states.push(row.getAttribute('data-state') || '');
            zips.push(row.getAttribute('data-zip') || '');
            phones.push(row.getAttribute('data-phone') || '');
            involvementTypes.push(row.getAttribute('data-involvement-id') || '');
        });

        // Build save data object matching the backend structure
        var saveData = {
            token: $.session.Token,
            updateIncidentId: SelectedIncidentId || '0',
            saveUpdate: SelectedIncidentId ? 'Update' : 'Save',

            // Incident Details
            incidentDate: iDateInput ? iDateInput.value : '',
            incidentTime: iTimeInput ? iTimeInput.value : '',
            reportedDate: rDateInput ? rDateInput.value : '',
            reportedTime: rTimeInput ? rTimeInput.value : '',
            subcategoryId: categorySelect ? categorySelect.value : '',
            locationDetailId: locationSelect ? locationSelect.value : '',
            summary: summaryTA ? UTIL.removeUnsavableNoteText(summaryTA.value) : '',
            note: actionTA ? UTIL.removeUnsavableNoteText(actionTA.value) : '',
            prevention: preventionTA ? UTIL.removeUnsavableNoteText(preventionTA.value) : '',
            contributingFactor: causeTA ? UTIL.removeUnsavableNoteText(causeTA.value) : '',

            // Employees Involved (pipe-delimited)
            employeeIdString: employeeIds.join('|'),
            employeeInvolvementIdString: employeeInvolvementIds.join('|'),
            notifyEmployeeString: notifyEmployees.join('|'),

            // Other People Involved (pipe-delimited)
            othersInvolvedNameString: names.join('|'),
            othersInvolvedCompanyString: companies.join('|'),
            othersInvolvedAddress1String: addresses1.join('|'),
            othersInvolvedAddress2String: addresses2.join('|'),
            othersInvolvedCityString: cities.join('|'),
            othersInvolvedStateString: states.join('|'),
            othersInvolvedZipCodeString: zips.join('|'),
            othersInvolvedPhoneString: phones.join('|'),
            othersInvolvedInvolvementTypeIdString: involvementTypes.join('|'),

            // Consumers Involved (pipe-delimited)
            consumerIdString: consumerIds.join('|'),
            involvementId: consumerInvolvementIds.join('|'),
            consumerIncidentLocationIdString: consumerLocationIds.join('|'),
            includeInCount: consumerIncludeCounts.join('|'),
            consumerInvolvedIdString: consumerInvolvedIds.join('|'),

            // Optional fields
            incidentTypeId: null,
            incidentTypeDesc: null,
            serviceLocationId: null,
            othersInvolvedInvolvementDescriptionString: null
        };

        console.log('Saving incident details:', saveData);

        // Call the save API
        incidentTrackingAjax.saveUpdateITIncident(saveData, function (response) {
            console.log('Incident details saved successfully', response);
            if (response && response.incidentId) {
                SelectedIncidentId = response.incidentId;
            }

            // Show success notification
            alert('Incident details saved successfully!');

            // Refresh the page to show updated data
            incidentOverview.init();
        });
    }


    function addAttachmentsToIT(attachments, reviewAttachments) {
        reviewAttachmentArray = reviewAttachments;
        attachments.forEach(attachment => {
            tempAttachmentArray.push(attachment);
        });
        attachmentCount = tempAttachmentArray.length + reviewAttachmentArray.length;

        if (attachmentsBtn) {
            var btnText = attachmentsBtn.querySelector('span');
            if (btnText) {
                btnText.innerText = `ATTACHMENTS (${attachmentCount})`;
            }
            if (attachmentCount > 0) {
                attachmentsBtn.classList.add('hasAttachments');
            } else {
                attachmentsBtn.classList.remove('hasAttachments');
            }
        }
    }

    function showIncidentDetails() {
        // Clear the content area
        if (contentDiv) contentDiv.innerHTML = '';

        // Remove active class from all individual nav links
        document.querySelectorAll("a.individual_nav.active").forEach(a => a.classList.remove("active"));

        // Add active class to Incident Details link
        var incidentDetailsLink = document.querySelector('a.incident_details_link');
        if (incidentDetailsLink) {
            incidentDetailsLink.classList.add('active');
        }

        // Build and show incident details content
        incidentDetailsSection = buildIncidentDetailsContent();
        if (contentDiv) contentDiv.appendChild(incidentDetailsSection);
    }
    //#endregion

    function buildSection() {
        var wrap = document.createElement('div');
        wrap.style.display = 'flex';
        wrap.style.gap = '20px';

        // Left navigation
        var navElementWrapper = document.createElement('div');
        navElementWrapper.classList.add('leftSidebar');
        navElementWrapper.style.width = '250px';
        navElementWrapper.style.flexShrink = '0';
        var navEle = buildNavigation();
        navElementWrapper.appendChild(navEle);
        wrap.appendChild(navElementWrapper);

        // Content area
        contentDiv = document.createElement('div');
        contentDiv.classList.add('contentArea');
        contentDiv.style.flex = '1';
        wrap.appendChild(contentDiv);

        return wrap;
    }

    function clearAllGlobalVariables() {
        tempAttachmentArray = [];
        reviewAttachmentArray = [];
        attachmentCount = 0;
        incidentDate = '';
        incidentTime = '';
        reportedDate = '';
        reportedTime = '';
        categoryId = '';
        locationId = '';
        summaryText = '';
        actionText = '';
        preventionText = '';
        factorsText = '';
        individualsInvolvedData = [];
        employeesInvolvedData = [];
        otherPeopleInvolvedData = [];
    }

    function init(incidentId, data) {
        formReadOnly = $.session.incidentTrackingUpdate === true ? false : true;
        SelectedIncidentId = incidentId;
        reviewData = data;
        // DEBUG: Check what data we have
        console.log('SelectedIncidentId:', SelectedIncidentId);
        console.log('reviewData:', reviewData);
        if (reviewData && reviewData.length > 0) {
            console.log('itConsumerInvolved:', reviewData[0].itConsumerInvolved);
            console.log('itEmployeeInvolved:', reviewData[0].itEmployeeInvolved);
        }

        // CLEAR FIRST, before loading new data
        clearAllGlobalVariables();

        // Initialize data arrays AFTER clearing
        individualsInvolvedData = [];
        employeesInvolvedData = [];
        otherPeopleInvolvedData = [];

        // Load data from reviewData if it exists
        if (reviewData && reviewData.length > 0) {
            if (reviewData[0].itConsumerInvolved) {
                individualsInvolvedData = reviewData[0].itConsumerInvolved;
            }
            if (reviewData[0].itEmployeeInvolved) {
                employeesInvolvedData = reviewData[0].itEmployeeInvolved;
            }
            if (reviewData[0].itOtherPeopleInvolved) {
                otherPeopleInvolvedData = reviewData[0].itOtherPeopleInvolved;
            }
        }

        DOM.clearActionCenter();
        var detailCard = buildSection();
        DOM.ACTIONCENTER.appendChild(detailCard);

        // Show incident details by default   
        showIncidentDetails();

        // Setup event delegation for navigation
        detailCard.addEventListener('click', function (event) {
            var target = event.target;
            if (target.classList.contains('individual_nav')) {
                event.preventDefault();
                handleIndividualNavEvents(event);
            }
            if (target.classList.contains('incident_details_link')) {
                event.preventDefault();
                showIncidentDetails();
            }
        });
    }

    return {
        init,
        checkRequiredFields,
        addAttachmentsToIT,
        clearAllGlobalVariables
    };
})();